<template>
  <div>
    <footer>
      <div class="footer">
        <div class="main-center">
          <div class="left">
            <div class="info f-bold">Earn Credits with Flexibility<br />A global higher education opportunity provider</div>
            <div class="logo"><img :src='this.$store.state.baseURL + "/new/images/logonew.png"' alt="Light Course"></div>
          </div>
          <div class="right">
            <ul>
              <li>
                <a class="f-bold" href="javascript:void(0)" @click="redrect2Url('about')">About Us</a>
                <a class="f-bold" href="javascript:void(0)" @click="redrect2Url('document')">How LightCourse Works</a>
                <a class="f-bold" href="javascript:void(0)" @click="redrect2Url('transfer')">How to Transfer Credit</a>
                <a class="f-bold" href="javascript:void(0)" @click="redrect2Url('toapply')">How to Apply</a>
                <a class="f-bold" href="javascript:void(0)" @click="redrect2Url('faq')">FAQ</a>
              </li>
              <li>
                <a class="f-bold" href="javascript:void(0)" @click="redrect2Url('course')">All Courses</a>
                <a class="f-bold" href="javascript:void(0)" @click="redrect2Url('activity')">Collaborate with Us</a>
                <a class="f-bold" href="javascript:void(0)" @click="redrect2Url('contact')">Contact Us</a>
                <a class="f-bold" href="javascript:void(0)" @click="redrect2Url('blog')">Blog</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="copyright">
			<span class="f-medium">
          Copyright &copy;{{updateYear}}
          All rights reserved. Lion Education International,LLC.  <a  class='f-medium' href='https://beian.miit.gov.cn' target='_blank'>蜀ICP备2020030077号-1</a>
			</span>
        </div>
      </div>
      <div class="cookie">
        <div class="main-center container">
          <p>LightCourse uses cookies to provide necessary website functionality, improve your experience and analyze
            our traffic. By using our website, you agree to our Terms of Service.</p>
          <a href="javascript:;">OK!</a>
        </div>
      </div>
    </footer>
	</div>
</template>

<script>
  export default {
    props: {

    },
    data(){
      return{
        updateYear: null,
      }
    },
    created() {
      let copyright = new Date();
      this.updateYear = copyright.getFullYear();
      function hideCookie() {
        $("footer .cookie").css({
          transform: "translateY(" + $("footer .cookie").innerHeight() + "px)",
        });
        $("body").css({
          paddingBottom: 0,
        });
      }
      function showCookie() {
        $("footer .cookie").css({
          transform: "translateY(0)",
        });
        $("footer").css({
          paddingBottom: $("footer .cookie").innerHeight() + "px",
        });
      }

      if ($.cookie("the_cookie") == "the_time") {
        hideCookie();
      } else {
        showCookie();
      }
      $("footer .cookie .container a").click(function () {
        $.cookie("the_cookie", "the_time", { expires: 1, path: "/" });
        hideCookie();
      });
    },
    mounted() {

    },
    methods: {
      redrect2Url(path) {
        this.$router.push('/' + path);
        this.homeActive = "";
        this.courseActive = "";
        this.programActive = "";
        if (path == "home") {
          this.homeActive = "active";
        } else if (path == "course") {
          this.courseActive = "active";
        } else if (path == "program") {
          this.programActive = "active";
        }
      },
    }
  }
</script>

<style scoped>
    .copy-btn-01,
    .copy-btn-02{
      transition: all .6s;
    }
    .copy-btn-01:hover,
    .copy-btn-02:hover{
      color: #00db6d !important;
    }
  .setBetween .item:nth-of-type(1):after {
    content: '';
    display: block;
    width: 1px;
    height: 100%;
    background: #3b52f6;
    position: absolute;
    right: 0;
    top: 0;
  }

  .setBetween .item {
    width: 50%;
  }

  .setBetween .item:nth-of-type(1) {
    padding-right: 20px !important;
    position: relative;
  }

  .setBetween .item:nth-of-type(2) {
    padding-right: 20px !important;
  }

  .setBetween .item:nth-of-type(1):after {
    width: 0px;
  }

  .a-line {
    padding-bottom: 0.8rem;
  }

  .a-btn {
    background: #3b52f6;
    /*display: inline-block;*/
    text-align: center;
    height: 3rem;
    line-height: 3rem;
    color: white;
  }

  .a-btn a {
    color: white !important;
    display: block;
    width: 100%;
    height: 100%;
  }

  .a-blue {
    color: #3b52f6;
  }

  .add-btn {
    text-align: right;
  }

  .add-btn a {
    border-radius: 0.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue